import { getUaMatchedMap } from '@/monitor/helper'
import type { Directive } from 'vue'

// 浏览器
const browser_info = getUaMatchedMap(navigator.userAgent)

const transformShow: Directive = {
  updated(el, binding) {
    el.style.position = 'absolute'
    el.style.width = '100%'
    if (browser_info.browser.Firefox) {
      if (binding.value) {
        el.style.zIndex = 0 // 显示元素
        el.style.visibility = 'visible' // 显示元素
      } else {
        el.style.zIndex = -1 // 隐藏元素
        el.style.visibility = 'hidden' // 隐藏元素
      }
    } else {
      if (binding.value) {
        el.style.display = 'block' // 显示元素
      } else {
        el.style.display = 'none' // 隐藏元素
      }
    }
  },
}

export default {
  name: 'transform-show',
  definition: transformShow,
}
